<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="620">
    <v-card>
        <v-toolbar class="mid-font" dense elevation="1" >
            <v-icon left >mdi-currency-php-off</v-icon><span class="va-underline">{{state=='new'?'New':'Edit'}} Expenses</span>
            <v-spacer/>
            <v-icon  @click="emitToParent('close')">mdi-close</v-icon>
          </v-toolbar>
        <v-card-text>
             <v-form
                ref="form"
                class="mt-4"
                v-model="valid"
                lazy-validation
              >
              <v-row>
                <v-col cols="6">
                  <v-menu
                                  ref="menu"
                                  v-model="menu"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="item.date"
                                       :rules="FieldRules('Date is required.')"
                                      label="Date"
                                     outlined
                                       dense
                                         hide-details
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="item.date"
                                    no-title
                                    scrollable
                                    @input="menu = false"
                                  >
                                
                                  </v-date-picker>
                                </v-menu>
                </v-col>
                <v-col cols="6">
                         <v-autocomplete
                        v-model="item.category"
                        :rules="textRules"
                        hide-details
                      required
                        :items="CATEGORIES"
                        outlined
                          dense
                        label="Category"
                        ></v-autocomplete> 
                </v-col>
               <v-col cols="6">
                       <v-autocomplete
                        v-model="item.payment_method"
                        :rules="textRules"
                      required
                        :items="['Online Payment', 'Bank Transfer', 'eWallet', 'Cash']"
                        outlined
                          dense
                          hide-details
                        label="Payment Method"
                        ></v-autocomplete> 
               </v-col> 
                <v-col cols="6">
                    <v-text-field
                  v-model="item.amount"
                    label="Amount"
                    outlined
                    dense
                    hide-details
                    :rules="textRules"
                  required
                  ></v-text-field>
               </v-col>
               <v-col cols="6">
                    <v-text-field
                  v-model="item.payee_to"
                    label="Payee/To"
                    outlined
                     hide-details
                    dense
                    :rules="textRules"
                  required
                  ></v-text-field>
                 </v-col> 
                 <v-col cols="6">
                    <v-text-field
                  v-model="item.ref_no"
                    label="Ref no. (Optional)"
                    outlined
                     hide-details
                    dense
                  required
                  ></v-text-field>
               </v-col>
                <v-col cols="12">
                  <v-textarea
                 v-model="item.description"
                 rows="2"
                  label="Expenses description"
                  outlined
                  hide-details
                  dense
                required
                ></v-textarea>
               </v-col>
               <v-col cols="4">
                    <v-autocomplete
                        v-model="item.status"
                        :rules="textRules"
                      required
                        :items="['Pending', 'Paid']"
                        outlined
                          dense
                          hide-details
                        label="status"
                        ></v-autocomplete> 
               </v-col>
                 <v-col cols="12">
                  Expenses Account
                  <v-divider class="mt-2 mb-2"/>
                       <v-autocomplete
                        v-model="selected_account"
                        :rules="textRules"
                        required
                        :items="accounts"
                        outlined
                        return-object
                        item-text="name"
                        dense
                        hide-details
                        label="Select Account"
                        ></v-autocomplete> 
                     <p class="font-italic">{{ selected_account.description }}</p>   
               </v-col> 
                <v-col cols="12">
                    Expenses Attachment
                  <v-divider class="mt-2 mb-2"/>
                <span v-if="item.attachments !='' && item.attachments != null">
                   <img 
                   width="150"
                   class="imgview"
                   @click="imgsrc = img, imgview=true"
                  v-for="(img,m) in item.attachments"
                  :key="m +'-am'"
                   :src="img">
            </span>
                               
                               <zera-s3-upload :show="s3upload" @zeraEvent="s3Ev"/>
                </v-col>
              </v-row>
             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
    <zera-image-viewer :show="imgview" :imgsrc="imgsrc" @DialogEvent="imgview = false"/>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    data: {
       type: Object,
        default: ()=>{}
    },
    accounts: {
        type: Array,
        default: ()=>[]
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      menu: false,
      s3upload: false,
      date:"",
      newpassword:'',
      show1: false,
      item: {},
      imgsrc:"",
      imgview:false,
      selected_account:{},
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      },
      ROLES() {
        return ['New Application', 'Verified', "Closed"]
      },
      CATEGORIES(){
       return  this.GET_SYSVARS('expenses_categories')
      }
  },
  watch: {
    show (v) {
      if (v) {
        this.item = {}
        this.s3upload = true
         if(this.state != 'new') {
              this.item=this.data
              this.setAccount()
          }
      } 
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
            this.state=='new'?this.Add():this.Update()
        }
      },
      s3Ev(e){
         if(e) {
            this.item.attachments = e
            this.s3upload = false
            
          }
      },
      setAccount(){
          var account  = this.accounts.reduce((acct,res)=>{
                if(acct.id == this.item.account_id) {
                  res = acct
                }
                return res
          },{})
          this.selected_account = account
      },
       Add: function() {
        this.item.account_name=this.selected_account.name
        this.item.account_id=this.$IsNum(this.selected_account.id)
        this.item.status = "Paid"
        this.item.amount = this.$IsNum(this.item.amount)
         this.item.date = this.$moment(this.item.date).format('YYYY-MM-DD')
        this.$http.post("new_expense", this.item).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          if(response.data.status){
              this.emitToParent("close")
          }
        }).catch(e => {
          console.log(e.data)
        })
     },
      Update: function() {
        this.item.account_name=this.selected_account.name
        this.item.account_id=this.$IsNum(this.selected_account.id)
         this.item.amount = this.$IsNum(this.item.amount)
         this.item.date = this.$moment(this.item.date).format('YYYY-MM-DD')
       this.$http.post("update_expense", this.item).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          if(response.data.status){
              this.emitToParent("close")
          }
        }).catch(e => {
          console.log(e.data)
        })
     },
   
    emitToParent () {
        this.$emit('DialogEvent', "")
    }
  }
}
</script>
